import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { apiClient } from "@/services/api-client";

/** The execution state of an action within a decision. */

/** The type of an action within a decision. */

/** The source of a decision suggestion. */

/** The generation status of a suggestion. */

/** A single action to be executed as part of a decision. */

/** A decision option the user can choose from within a suggestion. */

/** The AI-generated suggestion attached to a reminder. */

/** Response from the action center endpoint. */

/** Updates the state of a specific action after the FE performs the underlying domain action. */
export function updateActionState(_x, _x2, _x3, _x4) {
  return _updateActionState.apply(this, arguments);
}

/** Soft-deletes a suggested action the user doesn't want. */
function _updateActionState() {
  _updateActionState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(patientUid, reminderId, actionId, state) {
    var _yield$apiClient$patc, data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return apiClient.patch("/patients/".concat(patientUid, "/reminder/").concat(reminderId, "/action-center/action/").concat(actionId, "/"), {
            state: state
          });
        case 1:
          _yield$apiClient$patc = _context.v;
          data = _yield$apiClient$patc.data;
          return _context.a(2, data);
      }
    }, _callee);
  }));
  return _updateActionState.apply(this, arguments);
}
export function deleteAction(_x5, _x6, _x7) {
  return _deleteAction.apply(this, arguments);
}

/** Payload for the select/clear decision endpoint. */
function _deleteAction() {
  _deleteAction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(patientUid, reminderId, actionId) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return apiClient["delete"]("/patients/".concat(patientUid, "/reminder/").concat(reminderId, "/action-center/action/").concat(actionId, "/"));
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _deleteAction.apply(this, arguments);
}
/** Selects (or clears) the active decision for a suggestion. */
export function selectDecision(_x8, _x9, _x0) {
  return _selectDecision.apply(this, arguments);
}

/** Payload for the regenerate endpoint — refine with additional context. */
function _selectDecision() {
  _selectDecision = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(patientUid, reminderId, payload) {
    var _yield$apiClient$post, data;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return apiClient.post("/patients/".concat(patientUid, "/reminder/").concat(reminderId, "/action-center/decision/select/"), payload);
        case 1:
          _yield$apiClient$post = _context3.v;
          data = _yield$apiClient$post.data;
          return _context3.a(2, data);
      }
    }, _callee3);
  }));
  return _selectDecision.apply(this, arguments);
}
/** Response from the regenerate endpoint (202 Accepted). */
/** Soft-deletes the active run and enqueues a new generating run that refines the suggestion. */
export function regenerateSuggestion(_x1, _x10, _x11) {
  return _regenerateSuggestion.apply(this, arguments);
}

/** Fetches the active action center run (suggestion, decisions, actions) for a reminder. */
function _regenerateSuggestion() {
  _regenerateSuggestion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(patientUid, reminderId, payload) {
    var _yield$apiClient$post2, data;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return apiClient.post("/patients/".concat(patientUid, "/reminder/").concat(reminderId, "/action-center/regenerate/"), payload);
        case 1:
          _yield$apiClient$post2 = _context4.v;
          data = _yield$apiClient$post2.data;
          return _context4.a(2, data);
      }
    }, _callee4);
  }));
  return _regenerateSuggestion.apply(this, arguments);
}
export function fetchActionCenter(_x12, _x13) {
  return _fetchActionCenter.apply(this, arguments);
}
function _fetchActionCenter() {
  _fetchActionCenter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(patientUid, reminderId) {
    var _yield$apiClient$get, data;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _context5.n = 1;
          return apiClient.get("/patients/".concat(patientUid, "/reminder/").concat(reminderId, "/action-center/"));
        case 1:
          _yield$apiClient$get = _context5.v;
          data = _yield$apiClient$get.data;
          return _context5.a(2, data);
      }
    }, _callee5);
  }));
  return _fetchActionCenter.apply(this, arguments);
}